angular.module('unica_invitation.invitation_services')

.factory('InvitationEditService', function ($http, getBaseApiURL) {


	var invitationEditService = {};


	invitationEditService.update = function (registrationData)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation/update',
			data: registrationData
		}).then(function(result) {

			if ( result ) {
				return result.data.invitation;
			}

		});
	};


	invitationEditService.moveInvitation = function (invitationId, invitationListId)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation/move',
			data: {
				invitation_id: invitationId,
				invitation_list_id: invitationListId
			}
		}).then(function(result) {

			if ( result ) {
				return result.data.invitation;
			}

		});
	};


	invitationEditService.sendNotifications = function (registrationData)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation-tag/send-notifications',
			data: registrationData
		}).then(function(result) {

			if ( result ) {
				return result.data;
			}

		});

	};


	invitationEditService.updateInvitationTags = function (invitationId, invitationTagsData)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation-tag/update-invitation-tags',
			data: {
				invitation_id: invitationId,
				invitation_tags: invitationTagsData
			}
		}).then(function(result) {

			if ( result ) {
				return result.data.invitationTags;
			}

		});
	};


	invitationEditService.updateStatus = function (invitationId, status)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation/update-status',
			data: {
				id: invitationId,
				status: status
			}
		}).then(function(result) {

			if ( result ) {
				return result.data.invitation;
			}

		});
	};


	invitationEditService.updateNote = function (invitationId, service_note)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation/update-note',
			data: {
				id: invitationId,
				service_note: service_note
			}
		}).then(function(result) {

			if ( result ) {
				return result.data.invitation;
			}

		});
	};


	invitationEditService.resendInvitation = function( invitationId ) {
		var url  = getBaseApiURL + '/invitation/resend-invitation';

		return $http({
			method: 'post',
			url: url,
			data: {
				id: invitationId
			}
		}).then(function(result) {

			if ( result ) {
				return result.data.invitation;
			}

		});
	};


	invitationEditService.resendConfirmation = function( invitationId )
	{
		var url  = getBaseApiURL + '/invitation/resend-confirmation';

		return $http({
			method: 'post',
			url: url,
			data: {
				id: invitationId
			}
		}).then(function(result) {

			if ( result ) {
				return result.data.invitation;
			}

		});
	};


	return invitationEditService;

});